import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName } from '../../../../Util';

/** wraps a list of cards for propper formatting */
const CardsList = ({
  children,
  className
}) => {
  return (
    <div className={formatClassName(["cards-list", className])}>
      {children}
    </div>
  );
};

CardsList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default CardsList;
